import { Component } from '@angular/core';

@Component({
  selector: 'prism-report',
  templateUrl: './report.component.html',
  styleUrl: './report.component.scss'
})
export class ReportComponent {

}
